<template>
  <div class="list-box" style="padding: 0">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-select
          v-model="state.params.withholding_agent_id"
          placeholder="扣缴义务人"
          style="width: 200px"
        >
          <el-option
            v-for="item in state.withholding_agent_data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadWithholdingAgent()">
              刷新
            </el-button>
          </template>
        </el-select>
        <el-select
          v-model="state.params.tax_bureau_id"
          placeholder="税局"
          style="width: 200px"
        >
          <el-option
            v-for="item in state.taxbureau_data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadTaxBureau()">
              刷新
            </el-button>
          </template>
        </el-select>
        <el-radio-group v-model="state.params.status" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="-1">待执行</el-radio-button>
          <el-radio-button :value="0">已发送请求，待回执</el-radio-button>
          <el-radio-button :value="1">请求成功</el-radio-button>
          <el-radio-button :value="2">失败</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="state.params.log_type" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="0">从税局更新</el-radio-button>
          <el-radio-button :value="1">数据更新至税局</el-radio-button>
        </el-radio-group>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="操作时间"
          prop="update_time"
          width="180"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_ShowToolTip"
          min-width="140"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_ShowToolTip"
          min-width="200"
        />
        <el-table-column label="操作类型" min-width="100">
          <template #default="{ row }">
            <text v-if="row.log_type == 0" style="color: #1e90ff">
              从税局更新
            </text>
            <text v-else style="color: #ffa500">数据更新至税局</text>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100">
          <template #default="{ row }">
            <text v-if="row.status > 1" style="color: #f00">异常</text>
            <c_status
              v-else
              arr-name="deductionamount_log_status"
              :value="row.status"
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          prop="msg"
          label="错误原因"
          :formatter="$tab_ShowToolTip"
          min-width="240"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { personalpension_log } from "@/http/personalpension";
import {
  data_taxbureau_select,
  data_withholdingagent_select,
} from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadWithholdingAgent();
      onLoadTaxBureau();

      state.params.id = props.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      personalpension_log(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadWithholdingAgent,
      onRowClick,
      onLoadTaxBureau,
    };
  },
};
</script>
<style scoped></style>
